import React from 'react';
import {IMultiSelectProps, MultiSelectInput} from '~/components/Controls/Select';
import {FormField, hasError, IFieldProps, onChangeField} from '~/components/Form';
import {TableSortDirection} from '~/components/Table';
import {Intent} from '~/lib/intent';
import {ID} from '~/lib/model';
import {sortByString} from '~/lib/sort';
import {useBiddersQuery} from '~/modules/Bidders/queries';

interface ISearchableMultiSelectBidderProps extends IMultiSelectProps<ID> {
    agencyId?: number;
}

type IMultiSelectBidderProps = Omit<ISearchableMultiSelectBidderProps, 'items'>;


export const MultiSelectBidder = ({
    disabled,
    ...props
}: IMultiSelectBidderProps) => {
    const {data: bidders = [], isLoading} = useBiddersQuery();
    const items = bidders
        .filter(bidder => props.agencyId == null || bidder.agencyId == props.agencyId)
        .map(bidder => ({
            label: bidder.title,
            value: bidder.id
        }));
    return <MultiSelectInput {...props} disabled={disabled || isLoading}
        rightIcon={isLoading && <i className='fa fa-spinner fa-spin'/>}
        items={sortByString(items, 'label', TableSortDirection.ASC)}/>;
};

export const MultiSelectBidderField = (props: IFieldProps<IMultiSelectBidderProps>) => <FormField {...props}>
    <MultiSelectBidder {...props.options}
        intent={hasError(props) && Intent.DANGER}
        value={props.field.value} onChange={value => onChangeField(props, value)}
    />
</FormField>;
